export default {
  min: {
    title:
      'Entrega para a sua localização: Valor necessário para atingir o pedido mínimo (Subtotal excl. custos de entrega e gorjeta)',
    description:
      'Pedimos desculpa, ainda não pode encomendar. {{name}} definiu um valor mínimo de {{threshold}} (excl. custos de entrega)',
  },
  max: {
    title: 'Valor máximo de encomenda para entrega atingido (Total excl. custos de entrega)',
    description:
      'A sua encomenda atingiu o valor máximo de {{threshold}} para entrega online. Para encomendas acima deste valor, contacte-nos diretamente para que possamos organizar a entrega. Obrigado pela compreensão!',
  },
};
